import axios from 'axios';

class UploadFileService {
    
    uploadSpreadsheet(file, onUploadProgress) {
        let formData = new FormData();

        formData.append("file", file);

        return axios.post("/api/store-registration-file", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            onUploadProgress
        });
    }
    
    uploadPicture(file, id, file_type, onUploadProgress) {
        let formData = new FormData();

        formData.append("file", file);       
        formData.append('id', id);
        formData.append('file_type', file_type);

        return axios.post("/api/student-file", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            onUploadProgress
        });
    }

    getPicture($student_id) {
        return axios.get("/api/student-picture/"+$student_id)
    }

    getFiles(student_id) {
        return axios.get(`/api/student-get-files?student_id=${student_id}`)
    }
}

export default new UploadFileService();